export function genAppStoreUrl(lang) {
  const map = {en: 'us', ru: 'ru', ko: 'kr', ja: 'jp', es: 'es', de: 'de', fr: 'fr', tr: 'tr', pt: 'pt', vi: 'vi'};
  const appLang = map[lang] || 'us';
  return 'https://apps.apple.com/' + appLang + '/app/phemex/id1499601684';
}

export function genGooglePlayUrl(lang) {
  return 'https://play.google.com/store/apps/details?id=com.phemex.app&hl=' + lang;
}

export function genGoogleAPKPlayUrl(lang) {
  return 'https://static.phemex.com/android/phemex.apk';
}
